export const USER_ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  DESIGNER: 'designer',
  OUTSOURCE: 'outsource',
};

export const OVERSEAS_SERVICES = {
  PHOTO_AC: 'photo_ac',
  ILLUST_AC: 'illust_ac',
  SILHOUETTE_AC: 'silhouette_ac',
  NEWYEAR_AC: 'newyear_ac',
};

export const DATA_TYPE = {
  TEXT: 'text',
  ELEMENT: 'element',
  GRAPHIC: 'graphic',
  BACKGROUND: 'background',
  PHOTO: 'photo',
  ILLUST: 'illust',
  NEWYEAR: 'newyear_ac',
  SILHOUETTE: 'silhouette',
  ASSET: 'asset',
  TEMPLATE_IMAGE: 'template-image',
};

export const UI_HEIGHT = {
  HEADER: 68,
  TOOLBAR: 56,
  SIDE_MENU_BOTTOM_BAR: 48,
};

export const SUGGESTED_SIZE = [
  {
    nameIsTranslationKey: true,
    name: 'ace-suggested-size-sns',
    id: 'sns',
    items: [
      {
        type: 'TWITTER_HEADER',
        name: 'ace-suggested-size-twitter-header',
        icon: 'twitter',
        width: 1500,
        height: 500,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'TWITTER_POST',
        name: 'ace-suggested-size-twitter-post',
        icon: 'twitter',
        width: 1024,
        height: 512,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'INSTAGRAM_STORY',
        name: 'ace-suggested-size-instagram-story',
        icon: 'instagram',
        width: 1080,
        height: 1920,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'INSTAGRAM_POST',
        name: 'ace-suggested-size-instagram-post',
        icon: 'instagram',
        width: 2048,
        height: 2048,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'FACEBOOK_COVER',
        name: 'ace-suggested-size-facebook-cover',
        icon: 'facebook',
        width: 851,
        height: 315,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'FACEBOOK_AVATAR',
        name: 'ace-suggested-size-facebook-avatar',
        icon: 'facebook',
        width: 800,
        height: 800,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'FACEBOOK_POST',
        name: 'ace-suggested-size-facebook-post',
        icon: 'facebook',
        width: 940,
        height: 788,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'FACEBOOK_AD',
        name: 'ace-suggested-size-facebook-ad',
        icon: 'facebook',
        width: 1200,
        height: 628,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'TWITTER_HEADER',
        name: 'ace-suggested-size-twitter-header',
        icon: 'twitter',
        width: 1500,
        height: 500,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'TWITTER_POST',
        name: 'ace-suggested-size-twitter-post',
        icon: 'twitter',
        width: 1024,
        height: 512,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'INSTAGRAM_STORY',
        name: 'ace-suggested-size-instagram-story',

        width: 1080,
        height: 1920,
        unit: 'px',
        icon: 'instagram',
        prefix: 'fab',
      },
      {
        type: 'INSTAGRAM_POST',
        name: 'ace-suggested-size-instagram-post',
        icon: 'instagram',
        width: 2048,
        height: 2048,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'FACEBOOK_COVER',
        name: 'ace-suggested-size-facebook-cover',
        icon: 'facebook',
        width: 851,
        height: 315,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'FACEBOOK_AVATAR',
        name: 'ace-suggested-size-facebook-avatar',
        icon: 'facebook',
        width: 800,
        height: 800,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'FACEBOOK_POST',
        name: 'ace-suggested-size-facebook-post',
        icon: 'facebook',
        width: 940,
        height: 788,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'FACEBOOK_AD',
        name: 'ace-suggested-size-facebook-ad',
        icon: 'facebook',
        width: 1200,
        height: 628,
        unit: 'px',
        prefix: 'fab',
      },

      {
        type: 'PINTEREST_POST',
        name: 'ace-suggested-size-pinterest-post',
        icon: 'pinterest',
        width: 736,
        height: 1104,
        unit: 'px',
        prefix: 'fab',
      },
      {
        type: 'YOUTUBE_THUMBNAIL',
        name: 'ace-suggested-size-youtube-thumbnail',
        icon: 'youtube',
        width: 1280,
        height: 720,
        unit: 'px',
        prefix: 'fab',
      },
    ],
  },
  {
    nameIsTranslationKey: true,
    name: 'ace-suggested-size-printing',
    id: 'printing',
    items: [
      {
        type: 'A4',
        name: 'ace-suggested-size-a4',
        icon: 'file',
        width: 210,
        height: 297,
        unit: 'mm',
        prefix: 'far',
      },
      {
        type: 'A3',
        name: 'ace-suggested-size-a3',
        icon: 'file',
        width: 297,
        height: 420,
        unit: 'mm',
        prefix: 'far',
      },
      {
        type: 'POST_CARD',
        name: 'ace-suggested-size-postcard',
        icon: 'mail-bulk',
        width: 100,
        height: 148,
        unit: 'mm',
        prefix: 'fa',
      },
      {
        type: 'POSTER',
        name: 'ace-suggested-size-poster',
        icon: 'sticky-note',
        width: 457.2,
        height: 609.6,
        unit: 'mm',
        prefix: 'fa',
      },
      {
        type: 'customize_1280_1024',
        name: 'ace-suggested-size-customize',
        icon: 'file',
        width: 1280,
        height: 1024,
        unit: 'px',
        prefix: 'far',
      },
      {
        type: 'customize_1920_1080',
        name: 'ace-suggested-size-customize',
        icon: 'file',
        width: 1920,
        height: 1080,
        unit: 'px',
        prefix: 'far',
      },
      {
        type: 'customize_960_560',
        name: 'ace-suggested-size-customize',
        icon: 'file',
        width: 960,
        height: 560,
        unit: 'px',
        prefix: 'far',
      },
      {
        type: 'customize_640_480',
        name: 'ace-suggested-size-customize',
        icon: 'file',
        width: 640,
        height: 480,
        unit: 'px',
        prefix: 'far',
      },
      {
        type: 'customize_800_600',
        name: 'ace-suggested-size-customize',
        icon: 'file',
        width: 800,
        height: 600,
        unit: 'px',
        prefix: 'far',
      },
      {
        type: 'customize_1280_800',
        name: 'ace-suggested-size-customize',
        icon: 'file',
        width: 1280,
        height: 800,
        unit: 'px',
        prefix: 'far',
      },
    ],
  },
];

export const browserFonts = [
  // { id: -1, title: 'Arial', category_name: 'font-default' },
  // { id: -1, title: 'Arial Black', category_name: 'font-default' },
  // { id: -1, title: 'Helvetica', category_name: 'font-default' },
  // { id: -1, title: 'Verdana', category_name: 'font-default' },
  // { id: -1, title: 'Trebuchet MS', category_name: 'font-default' },
  // { id: -1, title: 'Tahoma', category_name: 'font-default' },
  // { id: -1, title: 'Times', category_name: 'font-default' },
  // { id: -1, title: 'Times New Roman', category_name: 'font-default' },
  // { id: -1, title: 'Georgia', category_name: 'font-default' },
  // { id: -1, title: 'Courier New', category_name: 'font-default' },
  // { id: -1, title: 'Courier', category_name: 'font-default' },
  // { id: -1, title: 'Comic Sans MS', category_name: 'font-default' },
  // { id: -1, title: 'Impact', category_name: 'font-default' },
];
export const browserFontByName = browserFonts.reduce(
  (res, item) => ({
    ...res,
    [item.title]: item,
  }),
  {},
);

export const OBJECT_TYPE = {
  IMAGE: 'image',
  TEXT: 'text',
  TEXTBOX: 'textbox',
  GROUP: 'group',
  RECT: 'rect',
  IMAGE_GROUP: 'imageGroup',
  MASK_GROUP: 'maskGroup',
  OBJECT_GROUP: 'objGroup',
  ACTIVE_SELECTION: 'activeSelection',
  USER_SELECTION: 'userSelection',
  BACKGROUND: 'background',
  ELEMENT: 'element',
  GRAPHIC: 'graphic',
  BEZIER_SHAPE: 'bezierShape',
  PATH: 'path',
  CHART: 'chart',
  LOADING_GROUP: 'loading-group',
  ARROW: 'arrow',
  CROP_LAYER: 'cropLayer',
  LOADING_LAYER: 'loadingLayer',
  SPRITE: 'sprite',
};

export const LINKED_INPUT_GROUP = {
  RECEIVER_INFO: 'receiver-info',
  RECEIVER_ADDRESS: 'receiver-address',
  SENDER_INFO: 'sender-info',
};
export const LINKED_INPUT_TYPE = {
  TOP_POSTAL_CODE: 'top-postal-code',
  BOTTOM_POSTAL_CODE: 'bottom-postal-code',
  COMPANY_NAME: 'company-name',
  DEPARTMENT_NAME: 'department-name',
  RECEIVER_POSITION: 'receiver-position',
  RECEIVER_NAME: 'receiver-name',
  RECEIVER_TITLE: 'receiver-title',
  RECEIVER_ADDRESS: 'receiver-address',
  SENDER_ADDRESS: 'sender-address',
  SENDER_NAME: 'sender-name',
  EXTRA: 'extra',
};

export const LANGUAGES = {
  JAPANESE: 'ja',
  ENGLISH: 'en',
  KOREAN: 'ko',
  VIETNAMESE: 'vi',
  TAIWANESE: 'tw',
};

export const SIDEBAR_MENU_ITEM = {
  SIZE: 'SIZE',
  TEMPLATE: 'TEMPLATE',
  NEW_YEAR_TEMPLATE: 'NEW_YEAR_TEMPLATE',
  ELEMENTS: 'ELEMENTS',
  DESIGNER_ELEMENTS: 'DESIGNER_ELEMENTS',
  TEXT: 'TEXT',
  MATERIAL_AC: 'MATERIAL_AC',
  FRAMES: 'FRAMES',
  DESIGNER: 'DESIGNER',
  UPLOAD: 'UPLOAD',
  UPLOAD_USER: 'UPLOAD_USER',
  PRINT_CARD: 'PRINT_CARD',
  PEN_TOOL: 'PEN_TOOL',
  CHART: 'CHART',
  FONT: 'FONT',
  COLOR_PICKER: 'COLOR_PICKER',
  LINE: 'LINE',
  SET_BACKGROUND: 'SET_BACKGROUND',
  SHADOW_TOOL: 'SHADOW_TOOL',
};

export const LANGUAGES_MENU = [
  {
    key: 'en',
    label: 'EN English',
  },
  {
    key: 'ja',
    label: 'JP 日本語',
  },
  {
    key: 'tw',
    label: 'TW 繁體中文',
  },
  {
    key: 'ko',
    label: 'KO 한국어',
  },
  {
    key: 'vi',
    label: 'VI Tiếng Việt',
  },
];

export const EXPORT_JOB_ACTIONS = {
  DOWNLOAD_JPG: 'DOWNLOAD_JPG',
  DOWNLOAD_PNG: 'DOWNLOAD_PNG',
  DOWNLOAD_PDF: 'DOWNLOAD_PDF',
  PRINT: 'PRINT',
};

export const EXPORT_JOB_STATUSES = {
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const COLOR_MODES = {
  RGB: 'RGB',
  CMYK: 'CMYK',
};

export const UPLOAD_TYPES = {
  JOB_INPUT: 'jobInput',
  ICC_PROFILE: 'iccProfile',
};

export const STROKE_MASK_OBJECT_TEMP = 'stroke-mask-object-temp';

export const DEFAULT_WORKAREA_BACKGROUND_PROPERTIES = {
  lockMovementY: true,
  lockMovementX: true,
  lockRotation: true,
  lockScalingFlip: true,
  lockScalingX: true,
  lockScalingY: true,
  lockSkewingX: true,
  lockSkewingY: true,
  hasControls: false,
  superType: OBJECT_TYPE.BACKGROUND,
  padding: 3,
  hoverCursor: 'default',
};

export const CANVAS_ACTIONS = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  MODIFIED: 'MODIFIED',
  SET_BACKGROUND: 'SET_BACKGROUND',
  POSITION_LAYER: 'POSITION_LAYER',
};

export const COLLAB_MODIFIED_ACTIONS = [
  'top',
  'left',
  'scaleX',
  'scaleY',
  'skewX',
  'skewY',
  'angle',
];

export const SOCKET_ACTIONS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  BROADCAST_ROOM: 'broadcast-room',
};

export const DESIGN_DOC_KEYS = {
  DESIGN_DATA: 'DESIGN_DATA',
};
export const DESIGN_DATA_KEYS = {
  ID: 'ID',
  TITLE: 'TITLE',
  PAGE_IDS: 'PAGE_IDS',
  PAGES: 'PAGES',
  FONTS_STORAGE: 'FONTS_STORAGE',
  IMAGE_SOURCES_STORAGE: 'IMAGE_SOURCES_STORAGE',
};
export const PAGE_KEYS = {
  ID: 'ID',
  OBJECT_IDS: 'OBJECT_IDS',
  OBJECTS: 'OBJECTS',
  WORKAREA: 'WORKAREA',
  IS_MODIFIED: 'IS_MODIFIED',
  IS_DELETED: 'IS_DELETED',
  USER_SELECTIONS: 'USER_SELECTIONS',
};
export const OBJECT_KEYS = {
  LEFT_RELATIVE_TO_WORKAREA: 'LEFT_RELATIVE_TO_WORKAREA',
  TOP_RELATIVE_TO_WORKAREA: 'TOP_RELATIVE_TO_WORKAREA',
  IS_DELETED: 'IS_DELETED',
};

export const OBJECT_EVENTS = {
  PROPERTIES_MODIFIED: 'properties:modified',
};

export const ULTRA_HD_SIZE = 3840;
export const FULL_HD_SIZE = 1920;
export const WEB_SIZE = 1280;

export const RESOLUTION_RESIZE = {
  Original: null,
  FullHD: FULL_HD_SIZE,
  UltraHD: ULTRA_HD_SIZE,
  Web: WEB_SIZE,
};

export const ID_BACKGROUND_WORKAREA = 'backgroundImage';

export const invalidKeywords = [
  '代孕',
  'surrogacy',
  'mang thai hộ',
  'đẻ thuê',
  '代理出産',
  '대리모',
  '假收入证',
  '仿结婚证',
  'tb888.online',
  'SEO57.com',
  'hgapp8.com',
  '仿精',
  '仿奢侈品',
  'KL99.CC',
  '试管婴儿',
];

export const MAX_LENGTH_OF_SEARCH_KEYWORD = 50;

export const PAGINATION_PAGE_TYPE = {
  PAGE: 'page',
  PREV: 'prev',
  NEXT: 'next',
  JUMP_PREV: 'jump-prev',
  JUMP_NEXT: 'jump-next',
};

export const DPI_CONFIG = {
  DEFAULT: 96,
  PRINT_PDF: 350,
  PRINT_JPG: 300,
};

const config = {
  defaultRole: process.env.DEFAULT_ROLE,
  defaultElementCategory: process.env.DEFAULT_ELEMENT_CATEGORY,
  apiDataURL: process.env.API_DATA_URL,
  apiCategoryURL: process.env.API_CATEGORY_URL,
  apiUserURL: process.env.API_USER_URL,
  apiExportURL: process.env.API_EXPORT_URL,
  apiOverseasSearchURL: process.env.API_OVERSEAS_SEARCH,
  apiOverseasSearchPhotoACURL: process.env.API_OVERSEAS_SEARCH_PHOTO_AC,
  apiDownloadOverseasPhotoURL: process.env.API_DOWNLOAD_OVERSEAS_PHOTO,
  apiDataOverseasURL: process.env.API_OVERSEAS_DATA,
  apiSearchURL: process.env.API_SEARCH_URL,
  socketServerURL: process.env.SOCKET_SERVER_URL,
  crdtServerURL: process.env.CRDT_SERVER_URL,
  staticURL: process.env.STATIC_URL,
  ssoURL: process.env.SSO_SERVER_URL,
  redirectURL: process.env.REDIRECT_URL,
  regionSite: process.env.REGION_SITE,
  wordpressHost: process.env.WORDPRESS_HOST,
  pdfHelpUrl: process.env.PDF_HELP_URL,
  listServicesHtmlUrl: process.env.LIST_SERVICES_HTML_URL,
  suggestionTemplatesDataUrl: process.env.SUGGESTION_TEMPLATE_DATA_URL,
  apiDetailPhotoOverseasURL: process.env.API_OVERSEAS_DETAIL_PHOTO_DATA,
  twitterConsumerKey: process.env.TWITTER_CONSUMER_KEY,
  twitterConsumerSecret: process.env.TWITTER_CONSUMER_SECRET,
  twitterCallBackURL: process.env.TWITTER_CALL_BACK_URL,
};

export default config;
